const translations = {
    datePlaceholder: 'MM/DD/YYYY'
};

export default translations;
